import React from 'react';
import { useSelector } from 'react-redux';
import SearchIcon404 from 'src/assets/svgExports/SearchIcon404';
import useWindowDimensions from 'src/utils/getWindowDimension';
import { redirectToHomePage } from 'src/utils/handleRedirectToHomePage';
import { PATH } from 'src/utils/routes';
import { RootState } from 'src/redux/reducers';

const ErrorMsg = () => {
  const { store } = useSelector((state: RootState) => ({
    store: state.storeReducer.store,
  }));

  const { isDesktop } = useWindowDimensions();
  const { height, width } = (() => {
    const size = isDesktop ? 200 : 100;
    return { height: size, width: size };
  })();

  const goToHomePage = () => {
    redirectToHomePage(PATH.PRODUCT, store?.domain);
  };

  return (
    <div
      className={`tw-static tw-flex tw-flex-col tw-bg-white ${isDesktop ? 'tw-my-[78px] tw-gap-[60px]' : 'tw-my-[138px] tw-gap-[48px]'}`}
    >
      <div
        className={`tw-flex tw-flex-col tw-items-center ${isDesktop ? 'tw-gap-[40px]' : 'tw-gap-[32px]'}`}
      >
        <SearchIcon404 height={height} width={width} />
        <div className="msg tw-flex tw-flex-col tw-gap-16 tw-text-center">
          <span
            className="tw-font-inter tw-text-[22px]/[32px]
            tw-font-semibold tw-text-[#000000]
            md:tw-text-[32px]/[44px] md:tw-font-semibold"
          >
            Uh oh, this page does not exist.
          </span>
          <span
            className="tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px]
            tw-text-[#00000099] md:tw-text-[18px]/7"
          >
            You may have mistyped the address or the <br /> page may have been removed.
          </span>
        </div>
      </div>

      <div className={`tw-flex tw-justify-center`}>
        <button
          onClick={goToHomePage}
          className="tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none
          tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]"
        >
          Go to home page
        </button>
      </div>
    </div>
  );
};

export default ErrorMsg;
